import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-630ad2ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-resizer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-bold" }, "Image Resizer", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "resize-controls flex items-center justify-center mt-6 p-4 bg-slate-800 rounded-xl border border-slate-700" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "width",
  class: "mr-2 text-slate-300"
}, "Width:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "height",
  class: "ml-4 mr-2 text-slate-300"
}, "Height:", -1))
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("input", {
      type: "file",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
      accept: "image/*",
      class: "block w-full text-sm text-slate-300 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-primary-600 file:text-white hover:file:bg-primary-700 mt-4 cursor-pointer"
    }, null, 32),
    (_ctx.image)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.width) = $event)),
              class: "w-24 px-2 py-1 bg-slate-900 border border-slate-600 rounded text-slate-200 focus:outline-none focus:ring-2 focus:ring-primary-500/50"
            }, null, 512), [
              [
                _vModelText,
                _ctx.width,
                void 0,
                { number: true }
              ]
            ]),
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.height) = $event)),
              class: "w-24 px-2 py-1 bg-slate-900 border border-slate-600 rounded text-slate-200 focus:outline-none focus:ring-2 focus:ring-primary-500/50"
            }, null, 512), [
              [
                _vModelText,
                _ctx.height,
                void 0,
                { number: true }
              ]
            ]),
            _createElementVNode("button", {
              class: "resize-btn bg-green-500 text-white px-4 py-2 rounded ml-4",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resizeImage && _ctx.resizeImage(...args)))
            }, "Resize")
          ]),
          _createElementVNode("img", {
            src: _ctx.image,
            alt: "Preview",
            class: "preview mt-4"
          }, null, 8, _hoisted_7),
          _createElementVNode("button", {
            class: "download-btn bg-green-500 text-white px-4 py-2 rounded mt-4",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.downloadImage && _ctx.downloadImage(...args)))
          }, "Download")
        ]))
      : _createCommentVNode("", true)
  ]))
}